import React, { Component } from 'react';
import { ButtonProps } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import Icon from '../../icons/Icon';

class AnimatedButton extends Component<AnimatedButtonProps> {
  render() {
    const { customSize, iconSize, disabled, customType, icon, text, className, loading, ...rest } = this.props;
    return (
      <button
        {...rest}
        disabled={loading}
        className={`${getOutline(customType)} ${getType(customType as AnimateButtonType) + ' '} ${getSize(customSize) + ' '}  ${disabled ? 'opacity-30 cursor-not-allowed' : ''} animate-button box-border rounded m-0 p-0  w-[120px] flex justify-start items-center relative ${className}`}
      >
        <div className={`${getSize(customSize)} + " "  w-[50%]`}>
          {loading ? (
            <ProgressSpinner style={{ height: '100%', width: '100%' }} />
          ) : (
            <div className={`flex h-full w-full items-center justify-center rounded-l-[0.25rem] ${getLeftSide(customType as AnimateButtonType)}`}>
              <Icon icon={icon} size={iconSize ? iconSize : '1.25rem'} />
            </div>
          )}
        </div>
        <span className={`px-3 w-full flex  items-center justify-center ${getCustomTextSize(customSize)}`}>{text}</span>
      </button>
    );
  }
}

function getCustomTextSize(customSize: string = 'md') {
  switch (customSize) {
    case 'sm':
      return 'text-xs 2xl:text-sm';
    case 'large':
      return 'text-xs';
    default:
      return 'text-xs 2xl:text-sm';
  }
}

function getLeftSide(customType: AnimateButtonType) {
  switch (customType) {
    case 'primary':
      return 'bg-primary text-white';
    case 'secondary':
      return 'bg-[#E3E9FC] text-[#728EFF]';
    case 'outlined':
      return 'bg-[#FBFBFB] text-[#4F4F4F]';
    case 'not-fraud':
      return 'bg-[#027A48] text-[#F2F2F2]';
    case 'fraud':
      return 'bg-[#D2332F] text-white';
    case 'warning':
      return 'bg-[#F0A042] text-white';
    default:
      return 'bg-[#E9F5FF] text-primary';
  }
}

function getOutline(customType: AnimateButtonType | undefined): string {
  switch (customType) {
    case 'primary':
      return 'outline outline-[0.5px] outline-primary';
    case 'secondary':
      return 'outline outline-[.5px]  outline-[#BECEFF] ';
    case 'outlined':
      return 'outline outline-[.5px] outline-[#CCCCCC] ';
    case 'not-fraud':
      return 'outline outline-[.5px] outline-[#027A48]';
    case 'fraud':
      return 'outline outline-[.5px] outline-[#D2332F]';
    case 'warning':
      return 'outline outline-[.5px] outline-[#FFB55D]';
    default:
      return 'animate-button-primary-outline';
  }
}

function getType(customType: AnimateButtonType) {
  switch (customType) {
    case 'primary':
      return 'animate-button-primary';
    case 'secondary':
      return 'animate-button-secondary';
    case 'outlined':
      return 'animate-button-outlined';
    case 'not-fraud':
      return 'animate-button-not-fraud';
    case 'fraud':
      return 'animate-button-fraud';
    case 'warning':
      return 'animate-button-warning';
    default:
      return 'animate-button-primary';
  }
}

function getSize(customSize: string = 'md') {
  switch (customSize) {
    case 'sm':
      return 'h-8 2xl:h-9';
    case 'md':
      return 'h-9 2xl:h-10';
    case 'lg':
      return 'h-10 2xl:h-12';
    default:
      return 'h-9 2xl:h-12';
  }
}

export type AnimateButtonType = 'primary' | 'secondary' | 'outlined' | 'fraud' | 'not-fraud' | 'warning';

export interface AnimatedButtonProps extends ButtonProps {
  icon: string;
  text: string;
  customType?: AnimateButtonType;
  customSize?: string;
  disabled?: boolean;
  iconSize?: number;
}

export default AnimatedButton;
